import { useEffect, useRef } from 'react';

export const useAutoFocusIf = (condition: boolean) => {
  const inputRef = useRef<HTMLInputElement & HTMLTextAreaElement>(null);
  useEffect(() => {
    const { current } = inputRef;
    if (condition) {
      current && current.focus();
    }
  }, [condition]);

  return inputRef;
};

export default useAutoFocusIf;
